<ftr-badge [color]="badgeColor" [text]="mfaStatus" />
